import React from "react";
import PropTypes from "prop-types";

const Warning = ({ height = "10px", icon, label, iconUrl }) => (
  <span className="label label-danger">
    {iconUrl ? (
      <img src={iconUrl} height={height} alt={iconUrl} />
    ) : (
      <i className={`fa fa-${icon}`} />
    )}
    &nbsp;&nbsp;{label}
  </span>
);

Warning.propTypes = {
  height: PropTypes.string,
  icon: PropTypes.string,
  iconUrl: PropTypes.string,
  label: PropTypes.string
};

export default function Warnings({ part }) {
  const hazmat = part.hazmat && <Warning label="Hazmat" icon="warning" />;
  const bio = part.bio_hazmat && <Warning label="Bio Hazmat" icon="flask" />;
  const llp = part.llp && <Warning label="LLP" icon="gear" />;
  const shelfLife = part.shelf_life && (
    <Warning
      label="Shelf Life"
      iconUrl="https://info-trader-assets.s3.us-east-2.amazonaws.com/icons/shelf_life.png"
      height="12px"
    />
  );
  const exportCompliance = part.export_compliance && (
    <Warning
      label="Export"
      iconUrl="https://info-trader-assets.s3.us-east-2.amazonaws.com/icons/export_compliance.png"
    />
  );

  return (
    <td>
      {hazmat}
      {bio}
      {llp}
      {shelfLife}
      {exportCompliance}
    </td>
  );
}

Warnings.propTypes = {
  part: PropTypes.shape({
    hazmat: PropTypes.bool.isRequired,
    bio_hazmat: PropTypes.bool.isRequired,
    llp: PropTypes.bool.isRequired,
    shelf_life: PropTypes.bool.isRequired
  })
};



// WEBPACK FOOTER //
// ./app/modules/parts/components/Search/Warnings.jsx